import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Logo from "../assets/tulus-logo.png";

import UserProfileDropdown from "../components/UserProfileDropdown";
import Validator from "./Validator";
import type { CommonProps } from "../common";

const useStyles = makeStyles((theme) => ({
  lefticon: {
    marginLeft: theme.spacing(4),
  },
  flex: {
    flex: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  logo: {
    "@media only screen and (min-width: 375px) and (max-width: 767px)": {
      width: "80%",
    },
    "@media only screen and (min-width: 768px) and (max-width: 1279px)": {
      width: "30%",
    },
    "@media only screen and (min-width: 1280px)": {
      width: "30%",
    },
  },
}));

const Dashboard = ({ user, signOut }: CommonProps) => {
  const classes = useStyles();

  return (
    <>
      <CssBaseline />
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="h6" noWrap>
            <img src={Logo} alt="Logo" className={classes.logo} />
          </Typography>
          <div className={classes.flex} />

          <div className={classes.lefticon}>
            <UserProfileDropdown user={user} signOut={signOut} />
          </div>
        </Toolbar>
      </AppBar>

      <main>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Validator user={user} />
        </Container>
      </main>
    </>
  );
};

export default Dashboard;
